import React, { FC } from 'react';

import { editionIsNew } from 'features/editions/helpers';
import { NftIconWithTooltip } from 'components/icons/NftIcon';
import * as Types from 'types';

type Props = {
  edition: Types.EditionWithArtwork;
  nftIndicatorEnabled?: boolean;
} & Types.Styleable;

const editionStatus = (edition: Types.EditionWithArtwork, nftIndicatorEnabled: boolean) => {
  if (edition === undefined) {
    return null;
  }
  const isNew = editionIsNew(edition);

  if (edition.artwork.nft && nftIndicatorEnabled) {
    const isMinted = Boolean(edition.certificate.ownerAddress);

    return (
      // Note we are passing empty style to override default
      <NftIconWithTooltip isMinted={isMinted} style={{ marginTop: '2px', fontSize: '11px' }} />
    );
  } else {
    return isNew ? <span className='key-value--color-cta'>New</span> : null;
  }
};

export const EditionInfo: FC<Props> = ({ edition, style, nftIndicatorEnabled = true }) => (
  <div style={style} className='key-value key-value--strong d-flex'>
    <span className='flex-grow-1'>{'Edition %d'.replace('%d', String(edition.editionNumber))}</span>
    {editionStatus(edition, nftIndicatorEnabled)}
  </div>
);
